import { useSupabaseLoader } from "../../../server/supabase/hooks";

import type { UseSupabaseLoaderState } from "../../../server/supabase/hooks/types";
import type { ProgramOverview } from "../program-landing";

/** The counts, next send and last edit of each program the caller can see, with its folders. */
export const useProgramOverview = (): UseSupabaseLoaderState<ProgramOverview[]> & {
  reload: () => void;
} =>
  useSupabaseLoader(async ({ supabase }) => {
    const { data, error } = await supabase.from("program_overview").select("*");
    if (error) throw error;
    return data;
  }, []);
